export class CloneFactory {

    private container!:HTMLElement;
    private rules:CSSStyleRule[]=[];
    private parentElement:HTMLElement;
    private elements:{original:HTMLElement,clone:HTMLElement}[]=[];
    public static instances:CloneFactory[]=[];
    private id;
    private pseudos:string[]=[
        '::after','::before',
        ':hover',':focus'
    ];

    constructor(id?:string,parent?:JQuery|string) {
        this.clean();
        this.id=id;
        if (parent===undefined) {
            this.parentElement=document.body;
        } else {
            this.parentElement=(typeof parent=='string')?$(parent)[0]:parent[0];
        }
        if (id!==undefined) {
            for (let cf of CloneFactory.instances) {
                if (cf.id===id && cf.parentElement===this.parentElement) return cf;
            }
        }
        this.container=document.createElement('div');
        this.container.classList.add('clone-factory');
        if (id) {
            this.container.classList.add('clone-factory-'+id);
        }
        CloneFactory.instances.push(this);
        this.parentElement.appendChild(this.container);
    }

    public addClass(myclass:string) {
        return $(this.container).addClass(myclass);
    }

    public find(sel:string) {
        return $(this.container).find(sel);
    }

    public clean() {
        for (let cf of CloneFactory.instances) {
            if (!document.body.contains(cf.parentElement)) {
                cf.destroy();
            }
        }
    }

    public destroy() {
        for (let element of this.elements) {
            element.original.style.visibility='';
        }
        this.container.remove();
        CloneFactory.instances=CloneFactory.instances.filter(e=>this!==e);
        setTimeout(
            ()=>{
                this.destroyRules();
            }
        ,500);
    }

    private copyEvents(from:JQuery, to:JQuery) {
        var data=(jQuery as any)['_data'];
        var events=data(from[0],"events");
        if (!from.length || !to.length || !events) return;

        to.each(function () {
            for (var type in events) {
                for (var k=0;k<events[type].length;k++) {
                    (jQuery as any).event['add'](this, type, events[type][k], events[type][k].data);
                }
            }
        });
    };

    private destroyRules() {
        for (let rule of this.rules) {
            if (!this.deleteRule(rule)) throw 'Could not delete rule.';
        }
    }

    public clone(e:JQuery):JQuery {
        for (let element of this.elements) {
            if (element.original===e[0]) return $(element.clone);
        }
        //Get untransformed position of the element and set that position as fixed.
        //A possible transformation will be applied through the classes.
        //We need to suspend any transitions temporarily to let the transform take
        //effect immediately for our measurement.
        var old_transition=e[0].style.transition;
        var old_transform=e[0].style.transform;
        e[0].style.transition='none';
        e[0].style.transform='none';
        let r=e[0].getBoundingClientRect();
        e[0].style.transform=old_transform;
        e[0].style.transition=old_transition;

        let clone=<HTMLElement>this.cloneNode(e[0],this.container);
        this.elements.push({original:e[0],clone});

        e[0].style.visibility='hidden';

        Object.assign(clone.style, {
            position: 'fixed',
            left: r.left+'px',
            top: r.top+'px',
            width: r.width+'px',
            height: r.height+'px'
        });
        return $(clone);
    }

    private cloneNode(el:Node,dest:Node):Node {
        //We don't use cloneNode(true) intentionally here because we want
        //to iterate through all nodes in order to copy the styles properly.
        let cl=el.cloneNode(false);

        if (cl instanceof Node) {
            dest.appendChild(cl);

            if (el instanceof HTMLElement && cl instanceof HTMLElement) {

                if (el instanceof HTMLImageElement && !el.src.match(/\.svg$/)) {
                    cl.setAttribute('width',el.naturalWidth+'');
                    cl.setAttribute('height',el.naturalHeight+'');
                }

                let erules=this.getMatchingRules(el);
                let crules=this.getMatchingRules(cl);
                let drules=this.getDifferentRules(erules,crules);
                for (let drule of drules) {
                    let myrule=this.findRule(drule);
                    cl.style.transition='none';
                    if (!myrule) {
                        let newsel=this.getUniqueClass();
                        cl.classList.add(newsel);
                        let parent=(<CSSGroupingRule>drule.parentRule)??drule.parentStyleSheet;
                        let pos=this.getRuleIndex(drule);
                        let sels=this.getSelectors(drule.selectorText);
                        for (let sel of sels) {
                            let asel=this.analyzeSelector(sel);
                            if (!el.matches(asel.selector)) continue;
                            let specificity=this.getSpecificity(asel.selector);
                            let newselstr=('.'+newsel).repeat(specificity)+asel.pseudo;
                            let idx=parent.insertRule(newselstr+' {'+drule.style.cssText+'}',pos);
                            let newrule=<CSSStyleRule>parent.cssRules[idx];
                            this.rules.push(newrule);
                        }
                    } else {
                        let sel=myrule.selectorText;
                        if (sel.indexOf('.clone-factory-')===0) {
                            sel=sel.substr(1);
                            let p=sel.indexOf('.');
                            if (p!==-1) sel=sel.substr(0,p);
                            cl.classList.add(sel);
                        }
                    }
                    cl.style.transition='';
                }
                this.copyEvents($(el),$(cl));
            }

            for (let en of Array.from(el.childNodes)) {
                this.cloneNode(en,cl);
            }

        }

        return cl;
    }

    private getSpecificity(sel:string):number {
        let matches=sel.trim().match(/\s+|\>/g);
        if (!matches) return 1;
        return matches.length+1;
    }

    private getUniqueClass():string {
        let newsel="clone-factory-"+Math.random().toString(16).slice(2);
        return newsel;
    }

    private deleteRule(rule:CSSStyleRule):boolean {
        let parent=(<CSSGroupingRule>rule.parentRule)??rule.parentStyleSheet;
        for (let k=0;k<parent.cssRules.length;k++) {
            let arule=parent.cssRules[k];
            if (arule===rule) {
                parent.deleteRule(k);
                return true;
            }
        }
        return false;
    }

    private findRule(rule:CSSStyleRule):CSSStyleRule|undefined {
        for (let arule of this.rules) {
            if (arule.style.cssText===rule.style.cssText &&
                arule.parentRule===rule.parentRule) return arule;
        }
    }

    private getRuleIndex(rule:CSSStyleRule):number {
        let parent=(<CSSGroupingRule>rule.parentRule)??rule.parentStyleSheet;
        for (let k=0;k<parent.cssRules.length;k++) {
            let arule=parent.cssRules[k];
            if (arule===rule) return k;
        }
        return -1;
    }

    private getDifferentRules(a:CSSStyleRule[],b:CSSStyleRule[]):CSSStyleRule[] {
        return a.filter((x:CSSStyleRule)=>(b.indexOf(x)==-1));
    }

    private hasParent(el:Node,elparent:Node):boolean {
        let eli:Node|null=el;
        while (eli) {
            if (eli===elparent) return true;
            eli=eli.parentNode;
        }
        return false;
    }

    //https://github.com/perry-mitchell/css-selector-splitter
    public getSelectors(selector:string):string[] {

        const BRACES = {
            "(": ")",
            "[": "]",
            '"': '"',
            "'": "'"
        };

        const CLOSING_BRACES = {
            ")": "(",
            "]": "["
        };

        let splitCharacters = [","];
        let currentBraces = [],
            selectorLen = selector.length,
            selectors = [],
            joiners = [],
            currentSelector = "",
            closingBraces = {};
        for (var i = 0; i < selectorLen; i += 1) {
            let char = selector[i];
            if (BRACES.hasOwnProperty(char)) {
                if (currentBraces.length === 0) {
                    currentBraces.push(char);
                } else {
                    let lastBrace = currentBraces[currentBraces.length - 1];
                    if (lastBrace === "\"" || lastBrace === "'") {
                        // within quotes
                        if (char === lastBrace) {
                            // closing quote
                            currentBraces.pop();
                        }
                    } else {
                        // inside brackets or square brackets
                        currentBraces.push(char);
                    }
                }
                currentSelector += char;
            } else if (CLOSING_BRACES.hasOwnProperty(char)) {
                let lastBrace = currentBraces[currentBraces.length - 1],
                    matchingOpener = CLOSING_BRACES[char as keyof typeof CLOSING_BRACES];
                if (lastBrace === matchingOpener) {
                    currentBraces.pop();
                }
                currentSelector += char;
            } else if (splitCharacters.indexOf(char) >= 0) {
                if (currentBraces.length <= 0) {
                    // we're not inside another block, so we can split using the comma/splitter
                    let lastJoiner = joiners[joiners.length - 1];
                    if (lastJoiner === " " && currentSelector.length <= 0) {
                        // we just split by a space, but there seems to be another split character, so use
                        // this new one instead of the previous space
                        joiners[joiners.length - 1] = char;
                    } else if (currentSelector.length <= 0) {
                        // skip this character, as it's just padding
                    } else {
                        // split by this character
                        let newLength = selectors.push(currentSelector.trim());
                        joiners[newLength - 1] = char;
                        currentSelector = "";
                    }
                } else {
                    // we're inside another block, so ignore the comma/splitter
                    currentSelector += char;
                }
            } else {
                // just add this character
                currentSelector += char;
            }
        }
        selectors.push(currentSelector.trim());
        return selectors.filter((cssSelector) => cssSelector.length > 0);
    }

    private analyzeSelector(selector:string):{selector:string,pseudo:string} {
        let regex=new RegExp('('+this.pseudos.join('|')+')+$');
        let pseudo_match=selector.match(regex);
        let pseudo=pseudo_match?pseudo_match[0]:'';
        selector=selector.replace(regex,'');
        return {selector,pseudo};
    }

    private getMatchingRulesInStylesheet(sheet:CSSStyleSheet|CSSMediaRule,element:HTMLElement):CSSStyleRule[] {
        let ruleList;
        let result:CSSStyleRule[]=[];
        try {ruleList=sheet.cssRules;} catch(e) {return result;}

        if (!ruleList) return result;

        for (let rule=0;rule<ruleList.length;rule++) {
            let arule=ruleList[rule];
            if (arule instanceof CSSImportRule) {
                if (arule.styleSheet) result=result.concat(this.getMatchingRulesInStylesheet(arule.styleSheet,element));
                continue;
            }
            if (arule instanceof CSSMediaRule) {
                result=result.concat(this.getMatchingRulesInStylesheet(arule,element));
                continue;
            }
            if (!(arule instanceof CSSStyleRule)) continue;

            for (let sel of this.getSelectors(arule.selectorText)) {
                let asel=this.analyzeSelector(sel);
                try {
                    if (asel.selector && element.matches(asel.selector)) {
                        result.push(arule);
                        break;
                    }
                    } catch(e) {
                    //Skip potentially unknown/invalid rules like ::--webkit-input-placeholder
                }
            }
        }

        return result;

    };

    private getMatchingRules(element:HTMLElement):CSSStyleRule[] {
        let sheets=element.ownerDocument.styleSheets;
        let result:CSSStyleRule[]=[];
        for (let k=0;k<sheets.length;k++) {
            result=result.concat(this.getMatchingRulesInStylesheet(sheets[k],element));
        }
        return result;
    };

}

export {};